import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'CHILDRENSPOOL',
  analyticsName: 'Childrens pool',
  queryKey: 'f_cPool',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const facts = hotel?.hotelFacts;

    if (!facts) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
        bucketName: 'pool_childrens',
      };
    }

    for (let i = 0; i < facts.length; i += 1) {
      const fact = facts[i];

      if (fact && fact.id === 'noPoolsChildren') {
        return {
          bucketId: fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE,
          bucketName: 'pool_childrens',
        };
      }
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'pool_childrens',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
